import React, { createContext, useContext, useEffect, useState } from 'react';

import { useIsMobile } from './useMobile';
import SignMessageModal from '../components/SignMessageModal';
import EventEmitter from 'events';
import ConnectWalletModal from '../components/ConnectWalletModal';
import InValidAddressModal from '../components/InValidAddressModal';
import { usePlayAccount } from './useAddress';

// 创建 Context
const ModalContext = createContext<any>(null);

export const Emitter = new EventEmitter();

export const useModalContext = () => {
  return useContext(ModalContext);
};

// 定义提供者组件
export const ModalProvider = ({ children }: any) => {
  const [signMessageModal, setSignMessageModal] = useState<any>(null);
  const [connectModal, setConnectModal] = useState<any>(null);
  const [checkAddressModal, setCheckAddressModal] = useState<any>(null);
  const { isMobile } = useIsMobile();

  const hideSignMessageModal = () => {
    setSignMessageModal(null);
  };
  const showSignMessageModal = () => {
    return new Promise(resolve => {
      const handleClick = () => {
        setSignMessageModal(null);
        resolve(true);
      };
      setSignMessageModal(
        <SignMessageModal
          handleClick={handleClick}
          style={isMobile ? { width: '30rem', fontSize: '1.2rem' } : {}}
        />
      );
    });
  };

  // connect wallet
  const showConnectModal = () => {
    return new Promise((resolve, reject) => {
      setConnectModal(
        <ConnectWalletModal
          title="Connect wallet"
          isOpen={true}
          connectCb={() => {
            setConnectModal(null);
          }}
          onClose={() => {
            setConnectModal(null);
          }}
        />
      );
      resolve(false);
    });
  };
  // check address wallet
  const showCheckAddressModal = ({
    gameAddress,
    connectAddress,
  }: {
    gameAddress: `0x${string}`;
    connectAddress: `0x${string}`;
  }) => {
    return new Promise((resolve, reject) => {
      setCheckAddressModal(
        <InValidAddressModal
          isOpen={true}
          gameAddress={gameAddress}
          connectAddress={connectAddress}
          onExit={() => {
            setCheckAddressModal(null);
          }}
        />
      );
      resolve(false);
    });
  };

  return (
    <ModalContext.Provider
      value={{
        signMessageModal,
        showSignMessageModal,
        hideSignMessageModal,
        connectModal,
        showConnectModal,
        checkAddressModal,
        showCheckAddressModal,
      }}
    >
      {children}
      {signMessageModal}
      {connectModal}
      {checkAddressModal}
    </ModalContext.Provider>
  );
};
